import EcoImg from 'eco-design/base/eco-img';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';

function TheComp() {
    const { t } = useLang('theProduct');
    useOnceInView('.on-the-road-F .F-title', () => {
        document.querySelector('.F-title')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-F GtmModuleData-section`}
            id="on-the-road-F"
            data-section-id={'on-the-road-F'}
            data-section-title={t('F_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1767840235619-jevxb1-compressed-full-width-carousel.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1767842633178-eg08sp-compressed-Frame%202094654778.jpg"
                isOpenLazy
            />
            <div className="F-title ani-1">{t('F_title')}</div>
        </section>
    );
}

export default TheComp;
